import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { fetchStatisticsData } from "../services/adminService";
import ModalWindow from "./modal/ModalWindow";

import * as XLSX from "xlsx";
import { formatDateExtended } from "../utils/dateUtils";

export default function StatisticsExport({
  exportModalVisible,
  setExportModalVisible,
}) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [inputError, setInputError] = useState("");

  const handleExport = async () => {
    if (!fromDate || !toDate) {
      setInputError("Prosím, vyberte počáteční a koncové datum.");
      return;
    }

    const startDate = new Date(fromDate);
    const endDate = new Date(toDate);

    if (endDate < startDate) {
      setInputError("Datum 'Do' nemůže být menší než datum 'Od'.");
      setFromDate("");
      return;
    }

    const result = await fetchStatisticsData(fromDate, toDate);

    if (result.success) {
      const stats = result.data;

      const headers = [
        "Číslo odběratele",
        "Počet přihlášení",
        "Poslední přihlášení",
        "Název",
        "Adresa",
        "IČ",
        "DIČ",
        "Telefon",
        "Email",
      ];

      // Prepare and format data: map each row to an array,
      // formatting the 'posledniPrihlaseni' field.
      const formatRow = (row) => [
        row.cisloOdberatele,
        row.pocetPrihlaseni,
        row.posledniPrihlaseni ? formatDateExtended(row.pocetPrihlaseni) : "",
        row.nazev,
        row.adresa,
        row.ic,
        row.dic,
        row.telefon,
        row.email,
      ];

      // Combine headers and data for "allUsers" sheet.
      const allUsersData = [headers, ...stats.allUsers.map(formatRow)];

      // Combine headers and data for "activeUsers" sheet.
      const activeUsersData = [headers, ...stats.activeUsers.map(formatRow)];

      // Create worksheets.
      const allUsersSheet = XLSX.utils.aoa_to_sheet(allUsersData);
      const activeUsersSheet = XLSX.utils.aoa_to_sheet(activeUsersData);

      // Create a new workbook and append the sheets.
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        allUsersSheet,
        "Všichni uživatelé"
      );
      XLSX.utils.book_append_sheet(
        workbook,
        activeUsersSheet,
        "Aktivní uživatelé"
      );

      // Write the workbook to a file and trigger the download.
      XLSX.writeFile(workbook, `statistika_${fromDate}_${toDate}.xlsx`, {
        compression: true,
      });
    }
  };

  return (
    <>
      <Button
        startIcon={<FileDownloadIcon />}
        variant="contained"
        sx={{ maxWidth: "60%", mt: 2 }}
        onClick={() => setExportModalVisible(!exportModalVisible)}
      >
        Exportovat do Excelu
      </Button>

      <ModalWindow
        visible={exportModalVisible}
        setVisible={setExportModalVisible}
      >
        <Typography variant="h6" sx={{ mt: 2 }}>
          Exportovat registrované a aktivní uživatele
        </Typography>
        <Typography variant="body2" sx={{ mt: 2, mb: 2, textAlign: "center" }}>
          Zvolte období od a do
        </Typography>

        {inputError && (
          <Alert
            severity="error"
            style={{ margin: "0 auto", maxWidth: "80%", marginBottom: "20px" }}
          >
            {inputError}
          </Alert>
        )}

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mb: 2 }}>
          <TextField
            label="Od"
            type="date"
            slotProps={{
              inputLabel: { shrink: true },
            }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <TextField
            label="Do"
            type="date"
            value={toDate}
            slotProps={{
              inputLabel: { shrink: true },
            }}
            onChange={(e) => setToDate(e.target.value)}
          />
        </Box>
        <Button
          startIcon={<FileDownloadIcon />}
          variant="contained"
          onClick={() => {
            handleExport();
          }}
        >
          Export
        </Button>
      </ModalWindow>
    </>
  );
}
